import { Bot, CirclePlus, Gem, Home, User } from "lucide-react";

const items = [
  ["home", Home, "Home"],
  ["bots", Bot, "Bots"],
  ["create", CirclePlus, "Create"],
  ["plans", Gem, "Plans"],
  ["profile", User, "Profile"]
];

export default function BottomNav({ active, setActive }) {
  return (
    <nav className="fixed inset-x-0 bottom-0 mx-auto max-w-[430px] border-t border-white/10 bg-black/80 px-3 pb-[calc(10px+env(safe-area-inset-bottom))] pt-2 backdrop-blur-xl">
      <div className="grid grid-cols-5 gap-1">
        {items.map(([id, Icon, label]) => (
          <button key={id} onClick={() => setActive(id)} className={`tap grid place-items-center rounded-app py-2 text-[11px] ${active === id ? "bg-violet-600 text-white" : "text-tg-hint"}`}>
            <Icon size={20} /><span>{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
